import React, { useEffect } from "react";
import { useAccount, useBalance, useReadContract, useWriteContract, useWaitForTransactionReceipt } from 'wagmi';
import { formatEther } from 'viem'

import { CharonConfig } from '../services/web3';
import Loader from "./Loader";

const GoodDeathMint = ({ data, setMinted }) => {
  const account = useAccount();
  const balance = useBalance({
    address: account.address,
  })

  const { data: hash, writeContract } = useWriteContract();
  const cost = useReadContract({
    ...CharonConfig,
    functionName: 'quoteCrossChainMint',
  })

  const { metadata, nonce, auth, tokenId } = data;

  const { isLoading: isConfirming, isSuccess: isConfirmed } = useWaitForTransactionReceipt({
    hash,
  })

  useEffect(() => { 
    if (isConfirmed) {
      setMinted(true)
    }
  }, [isConfirmed, setMinted])

  const onSubmit = (e) => {
    e.preventDefault()
    writeContract({
      to: CharonConfig.address,
      abi: CharonConfig.abi,
      functionName: 'sendCrossChainMint',
      args: [metadata, tokenId, nonce, auth],
      value: cost.data,
    })
  }
  return (
    <form onSubmit={onSubmit}>
      {cost && !cost.error && cost.data && !isConfirmed && !isConfirming ? (
        balance && balance.data && balance.data.value >= cost.data ? (
          <div className="button-parent"><input type="submit" value="Send Transaction"/></div>
        ) : (
          <p className="error">Insufficient balance. At current gas prices this interaction will cost {formatEther(cost.data)} POL (Matic). This is a high estimate, to ensure the Ethereum mainnet side of the transaction succeeds, because if it fails, the Polygon side will not revert. You will be refunded any unused portion of the fees in ETH on mainnet.</p>
        )
      ) : null}
      {hash && <div className="hash">Transaction Sent: {hash}</div>}
      {isConfirming && <Loader />}
      {isConfirmed && <div>Transaction confirmed.</div>}
    </form>
  )
}

export default GoodDeathMint;